import React from "react";
import { Icon, Form, Input } from "antd";

import {
	getQuestionFile,
	getQuestionFilePreview,
} from "../../../store/thunks/get-file";

import Attachment from "../../attachments/attachment";

const QuestionField = (props) => {
	const {
		form: { getFieldDecorator, setFieldsValue, getFieldValue },
		questionId,
	} = props;
	const uploadedFiles = [
		...(getFieldValue(`questions[${questionId}].files`) || []),
	];
	const validateStatus =
		getFieldValue(`questions[${questionId}].title`)?.length === 120
			? "warning"
			: "";

	return (
		<div className="question">
			<div className="question-options">
				<Form.Item
					label="Вопрос"
					className="field"
					validateStatus={validateStatus}
					help={validateStatus ? "Достигнут лимит в 120 символов" : undefined}
				>
					{getFieldDecorator(`questions[${questionId}].title`, {
						initialValue: "",
					})(<Input placeholder="Вопрос" className="input" maxLength={120} />)}
				</Form.Item>

				<label className="add-file">
					{getFieldDecorator(`questions[${questionId}].files`, {
						getValueFromEvent: (e) => {
							return [...uploadedFiles, ...e.target.files];
						},
						valuePropName: "files",
					})(<input type="file" className="input" multiple />)}
					<Icon type="file-add" className="icon" />
				</label>
			</div>
			{uploadedFiles.length > 0 && (
				<div className="attachments">
					{uploadedFiles.map((file, index) => (
						<Attachment
							key={index}
							getFile={() => {
								return getQuestionFile(questionId, file.fileName);
							}}
							uploadedFileText={file.name}
							onDelete={() => {
								setFieldsValue({
									[`questions[${questionId}].files`]: [
										...uploadedFiles.filter((attach) => {
											return attach.name !== file.name;
										}),
									],
								});
							}}
							loadPreview={() => {
								return getQuestionFilePreview(questionId, file.fileName);
							}}
						/>
					))}
				</div>
			)}
		</div>
	);
};

export default QuestionField;
